import { Icon } from "PFComponents/icon";
import { IconName } from "PFTheme/graphics/icons";
import { Experience } from "PFTypes";

import { getViewBox, LINE_WT, RADIUS } from "../constants";
import { ExperienceCommonProps, ParentChildCommonProps } from "../experience_level.types";

type NoExperienceProps = {
  requiredExperience: Experience;
  size: number;
} & ParentChildCommonProps &
  Pick<ExperienceCommonProps, "experienceLevels">;

const getNoExperienceIcon = (hasParentValues?: boolean, hasChildValues?: boolean): IconName => {
  if (hasParentValues && hasChildValues) {
    return "substitute-parent-child";
  }
  if (hasParentValues) {
    return "substitute-parent";
  }
  if (hasChildValues) {
    return "substitute-child";
  }

  return "cross";
};

export const NoExperience = ({
  requiredExperience,
  hasChildValues,
  hasParentValues,
  size,
  experienceLevels
}: NoExperienceProps) => {
  const index = experienceLevels.indexOf(requiredExperience);
  const iconName = getNoExperienceIcon(hasParentValues, hasChildValues);
  const hasParentChildRelation = hasChildValues || hasParentValues;

  return (
    <svg height={size} viewBox={getViewBox(experienceLevels.length)}>
      <Icon
        name={iconName}
        color={hasParentChildRelation ? "paletteOrange3" : "paletteRed0"}
        size="xxxs"
        x={index * (2 * RADIUS + LINE_WT)}
      />
    </svg>
  );
};
